module.exports = __webpack_public_path__ + "img/wuyefuwu.426bf695.png";